import * as R from 'ramda'
import { LIMITS } from '@weblite/permission'
import {
  reqSyncUserPreferences,
  SyncUserPreferences,
} from '@weblite/ts-action/user-preferences'
import { request, requestNow } from '$setup/ws'
import { isClientsRoom } from '$logic/room'
import { userPreferencesStorage } from './storage'
import * as sync from './offline-sync'

export const PINNED_ROOMS_COUNT = 10
// const PINNED_ROOMS_COUNT = LIMITS.pinnedRoomsCount

export async function getPinnedRooms() {
  const { pinnedRooms } = await userPreferencesStorage.get()
  return pinnedRooms
}

export async function pinRooms(roomIds: string[]) {
  const patch = { roomIds, action: 'ADD', date: new Date() } as const

  const oldPinnedRooms = await getPinnedRooms()

  const unset = await sync.set(patch)
  await userPreferencesStorage.set({
    pinnedRooms: [...roomIds, ...oldPinnedRooms].slice(0, PINNED_ROOMS_COUNT),
  })

  request<SyncUserPreferences>(
    reqSyncUserPreferences({ patches: [patch] }),
  ).then(async res => {
    await userPreferencesStorage.set(res.payload)
    unset()
  })
}

export async function unPinRooms(roomIds: string[]) {
  const patch = { roomIds, action: 'DELETE', date: new Date() } as const
  const oldPinnedRooms = await getPinnedRooms()

  const pinnedRooms = R.difference(oldPinnedRooms, roomIds)
  if (pinnedRooms.length === oldPinnedRooms.length) return

  await sync.set({ action: 'DELETE', date: new Date(), roomIds })
  await userPreferencesStorage.set({ pinnedRooms })

  request<SyncUserPreferences>(
    reqSyncUserPreferences({ patches: [patch] }),
  ).then(async res => {
    await userPreferencesStorage.set(res.payload)
  })
}

export async function syncUserPreferences(): Promise<void> {
  const { items, del, release } = await sync.get()
  try {
    const res = await requestNow<SyncUserPreferences>(
      reqSyncUserPreferences({ patches: items }),
    )
    const { pinnedRooms: rawPinnedRooms, ...fields } = res.payload
    const pinnedRooms = rawPinnedRooms.filter(isClientsRoom)
    await userPreferencesStorage.set({ ...fields, pinnedRooms })
    await del()
    release()
    if (pinnedRooms.length !== rawPinnedRooms.length)
      unPinRooms(rawPinnedRooms.filter(id => !isClientsRoom(id)))
  } catch (e) {
    release()
  }
}
